import * as File from "./file";
import * as Link from "./link";
import * as Magazine from "./magazine";

export enum ContentType {
  Link = 1,
  File = 2,
  Post = 3,
  Product = 4,
  Article = 5,
}

export enum Sort {
  Oldest = 0,
  Newest = 1,
  MostLikesAndShares = 4,
}

export type User = {
  id?: string | null;
  urlKey?: string | null;
  linksRoomId?: string | null;
  nickName?: string | null;
  fullName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
};

export type Params = {
  pageNumber: number;
  pageSize: number;
  contentType?: ContentType;
  shareTopic?: string;
  shareableOnly?: boolean;
  sort: Sort;
};

export type Item = {
  contentType: ContentType;
  contentId: string;
  sharedAt: string;
  isReshared: boolean;
  isShareable: boolean;
  isPublic: boolean;
  shareTopics: string[];
  likeCount: number;
  reshareCount: number;
  totalLikesAndReshares: number;
  alreadyLikedByMe: boolean;
  alreadyResharedByMe: boolean;
  seenByMe: boolean;
  originalOwner?: User | null;
  resharedBy?: User | null;
  link?: Link.Item | null;
  file?: File.Item | null;
  product?: Magazine.ProductItem | null;
  article?: Magazine.ArticleItem | null;
  post?: Magazine.PostItem | null;
};
